module.exports = __webpack_public_path__ + "f1a3d77cbdc8e4ac8faf5475e7000382.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/icons/_stay_.png
 ** module id = 661
 ** module chunks = 0
 **/